import React, { useState, useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import {
	Box,
	Typography,
	Button,
	Dialog,
	FormControl,
	FormLabel,
	TextField,
	TextareaAutosize,
	IconButton,
} from "@mui/material";
import Axios from "axios";
import constants from "../Constants";
import AlertMsg from "../component/AlertMsg";
import LogoAndTheme from "../component/LogoAndTheme";
import CloseIcon from "@mui/icons-material/Close";

function EditSchoolModal(props) {
	const { info, editApi, open, setOpen, msg, setMsg, fetchData } = props;
	const [loading, setLoading] = useState(false);
	// State to edit school
	const [nameToEdit, setNameToEdit] = useState(info.name);
	const [cityToEdit, setCityToEdit] = useState(info.city);
	const [addressToEdit, setAddressToEdit] = useState(info.address);
	const [telToEdit, setTelToEdit] = useState(info.tel);
	const [mailToEdit, setMailToEdit] = useState(info.mail);
	const [webToEdit, setWebToEdit] = useState(info.website);
	const [telegramToEdit, setTelegramToEdit] = useState(info.telegram);
	const [instagramToEdit, setInstagramToEdit] = useState(info.instagram);
	const [domainToEdit, setDomainToEdit] = useState(info.domain);
	const [descToEdit, setdescToEdit] = useState(info.description);
	const [loadingImg, setLoadingImg] = useState(false);
	const [uploadLogoMsg, setUploadLogoMsg] = useState(null);
	const [themeMsg, setThemeMsg] = useState(null);

	// edit theme
	const [color1, setColor1] = useState();
	const [color2, setColor2] = useState();
	const [color3, setColor3] = useState();
	const [color4, setColor4] = useState();

	const addThemeToEdit = async () => {
		const token = localStorage.getItem("schoolToken");
		const data = {
			theme: {
				primary: color1,
				secondary: color2,
				text: color3,
				background: color4,
			},
		};

		try {
			const response = await Axios.post(
				constants.baseUrl + "/school/theme",
				data,
				{
					headers: {
						authorization: "Bearer " + token,
					},
				}
			);
			const status = response.data.status;
			if (status === 202) {
				setThemeMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: "تم رنگی مشخص شد",
				});
			} else {
				setThemeMsg({
					type: false,
					header: "تلاش ناموفق",
					message: "ثبت تم رنگی انجام نشد ، دوباره تلاش کنید",
				});
			}
		} catch (err) {
			setThemeMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		}
	};

	useEffect(() => {
		if (info.color && Object.keys(info).length > 0) {
			setColor1(JSON.parse(info.color).primary);
			setColor2(JSON.parse(info.color).secondary);
			setColor3(JSON.parse(info.color).text);
			setColor4(JSON.parse(info.color).background);
		} else {
			setColor1("#35284A");
			setColor2("#FB7D79");
			setColor3("#ffffff");
			setColor4("#35284A");
		}
	}, [info]);

	useEffect(() => {
		setNameToEdit(info.name);
		setCityToEdit(info.city);
		setAddressToEdit(info.address);
		setTelToEdit(info.tel);
		setMailToEdit(info.mail);
		setWebToEdit(info.website);
		setTelegramToEdit(info.telegram);
		setInstagramToEdit(info.instagram);
		setDomainToEdit(info.domain);
		setdescToEdit(info.description);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

	// edit form
	const submitButtonHandler = async () => {
		const data = {
			name: nameToEdit,
			city: cityToEdit,
			address: addressToEdit,
			tel: telToEdit,
			mail: mailToEdit,
			website: webToEdit,
			telegram: telegramToEdit,
			instagram: instagramToEdit,
			domain: domainToEdit,
			description: descToEdit,
		};
		setLoading(true);
		addThemeToEdit();
		await editApi(data);
		setLoading(false);
	};

	const handleNameChange = e => {
		setNameToEdit(e.target.value);
	};
	const handleAddressChange = e => {
		setAddressToEdit(e.target.value);
	};
	const handleTelChange = e => {
		setTelToEdit(e.target.value);
	};
	const handleMailChange = e => {
		setMailToEdit(e.target.value);
	};
	const handleWebChange = e => {
		setWebToEdit(e.target.value);
	};
	const handleTelegramChange = e => {
		setTelegramToEdit(e.target.value);
	};
	const handleInstagramChange = e => {
		setInstagramToEdit(e.target.value);
	};
	const handleDomainChange = e => {
		setDomainToEdit(e.target.value);
	};
	const handleDescChange = e => {
		setdescToEdit(e.target.value);
	};

	// edit profile
	const beforeUpload = file => {
		const isJpgOrPng =
			file.type === "image/jpeg" ||
			file.type === "image/jpg" ||
			file.type === "image/png";
		if (!isJpgOrPng) {
			return false;
		} else {
			return true;
		}
	};
	const handleChange = async info => {
		if (!beforeUpload(info.target.files[0])) {
			setUploadLogoMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "فایل صحیح انتخاب کنید",
			});
			return;
		}
		setLoadingImg(true);
		const token = localStorage.getItem("schoolToken");
		const data = new FormData();
		data.append("avatar", info.target.files[0]);
		try {
			const response = await Axios.post(constants.baseUrl + "/user/avatar", data, {
				headers: {
					authorization: "Bearer " + token,
				},
			});
			const status = response.data.status;
			if (status === 202) {
				setUploadLogoMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: "لوگو بارگذاری شد",
				});
				fetchData();
				setLoadingImg(false);
			} else {
				setUploadLogoMsg({
					type: false,
					header: "تلاش ناموفق",
					message: "بارگذاری لوگو انجام نشد ، دوباره تلاش کنید",
				});
				setLoadingImg(false);
			}
		} catch (err) {
			setUploadLogoMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
			setLoadingImg(false);
		}
	};

	const inputs = [
		{ id: 1, lable: "نام مدرسه", value: nameToEdit, onChange: handleNameChange },
		{
			id: 2,
			lable: "استان",
			value: cityToEdit === "" ? "نامشخص" : cityToEdit,
			disabled: true,
		},
		{ id: 3, lable: "آدرس", value: addressToEdit, onChange: handleAddressChange },
		{ id: 4, lable: "شماره تماس", value: telToEdit, onChange: handleTelChange },
		{
			id: 5,
			lable: "پست الکترونیکی",
			value: mailToEdit,
			onChange: handleMailChange,
		},
		{ id: 6, lable: "وبسایت", value: webToEdit, onChange: handleWebChange },
		{
			id: 7,
			lable: "تلگرام",
			value: telegramToEdit,
			onChange: handleTelegramChange,
		},
		{
			id: 8,
			lable: "اینستاگرام",
			value: instagramToEdit,
			onChange: handleInstagramChange,
		},
		{
			id: 9,
			lable: "دامنه",
			value: domainToEdit,
			onChange: handleDomainChange,
		},
		{
			id: 10,
			lable: "توضیحات",
			value: descToEdit,
			onChange: handleDescChange,
		},
	];

	return (
		<Dialog open={open} fullWidth maxWidth="md">
			<Box p={2}>
				<IconButton
					sx={{ position: "absolute", top: 5, left: 5 }}
					onClick={() => {
						setOpen(false);
						setMsg(null);
						setUploadLogoMsg(null);
						setThemeMsg(null);
					}}>
					<CloseIcon />
				</IconButton>
				<Typography fontSize={16} fontWeight={"bold"} mb={2}>
					ویرایش اطلاعات مدرسه
				</Typography>
				<LogoAndTheme
					loadingImg={loadingImg}
					handleChange={handleChange}
					color1={color1}
					setColor1={setColor1}
					color2={color2}
					setColor2={setColor2}
					color3={color3}
					setColor3={setColor3}
					color4={color4}
					setColor4={setColor4}
				/>
				{uploadLogoMsg ? (
					uploadLogoMsg.type ? (
						<AlertMsg message={uploadLogoMsg} type={"success"} />
					) : (
						<AlertMsg message={uploadLogoMsg} type={"error"} />
					)
				) : null}
				{inputs.map(item => (
					<FormControl key={item.id} fullWidth margin="normal">
						<FormLabel sx={{ fontWeight: "bold", mb: 0.7 }}>{item.lable}</FormLabel>
						{item.id === 3 || item.id === 10 ? (
							<TextareaAutosize
								value={item.value}
								onChange={item.onChange}
								placeholder={item.lable}
								minRows={3}
								style={{ fontFamily: "Iran Sans", padding: "7px" }}
							/>
						) : (
							<TextField
								value={item.value}
								onChange={item.onChange}
								placeholder={item.lable}
								disabled={item.disabled}
							/>
						)}
					</FormControl>
				))}

				{msg ? (
					msg.type ? (
						<AlertMsg message={msg} type={"success"} />
					) : (
						<AlertMsg message={msg} type={"error"} />
					)
				) : null}

				{themeMsg ? (
					themeMsg.type ? (
						<AlertMsg message={themeMsg} type={"success"} />
					) : (
						<AlertMsg message={themeMsg} type={"error"} />
					)
				) : null}

				<LoadingButton
					variant="contained"
					color="secondary"
					onClick={loading ? () => {} : submitButtonHandler}
					sx={{ fontSize: "16px", color: "white", my: 1 }}
					loading={loading}>
					ویرایش
				</LoadingButton>
				<Button
					variant="contained"
					sx={{ fontSize: "16px", mr: 2, my: 1 }}
					onClick={() => {
						setOpen(false);
						setMsg(null);
						setUploadLogoMsg(null);
						setThemeMsg(null);
					}}>
					انصراف
				</Button>
			</Box>
		</Dialog>
	);
}

export default EditSchoolModal;
